import {Component, Input} from '@angular/core';
import {DEFAULT_LOADER_FLASH, ISharedLoadingG} from '../../../../models/animations';

/**
 * Overlay modal that shows the shared Gallix loading G with an optional message.
 */
@Component({
  selector: 'app-shared-loading-modal',
  templateUrl: './shared-loading-modal.component.html',
  styleUrls: ['./shared-loading-modal.component.scss'],
  standalone: false,
})
export class SharedLoadingModalComponent {
  @Input() message: string = 'Loading…';

  protected readonly animation: Readonly<ISharedLoadingG> = DEFAULT_LOADER_FLASH;
}
